import moment from 'moment/dist/moment.js';
import 'moment/dist/locale/ko';

export default moment;
export const isMoment = moment.isMoment;
